/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Adapted autoplay modes from player - matches avia-js exactly
 * @see {@link https://avia.cbsivideo.com/avia-js/latest/docs/api/player/enum/Autoplay}
 */
export enum PlayerAdapterAutoplay {
	NONE = 'none',
	ATTEMPT_MUTED = 'attemptMuted',
	ATTEMPT_UNMUTED = 'attemptUnmuted',
	ATTEMPT_UNMUTED_THEN_MUTED = 'attemptUnmutedThenMuted'
}